import { useCallback } from 'react';

import type { PublishProvidedStatementReferencesResult } from '../../model/providedReferences';
import { formatProvidePublishToast } from '../../model/referenceCopy';

import { useHaptic } from '@/hooks/useHaptic';
import { useToaster } from '@/hooks/useToaster';

/**
 * Confirms a provide-phase publish. The publish closes the wizard at once,
 * so without a toast the surface just vanishes and a less-confident expert
 * can't tell it landed; this mirrors the search flow's published toast and
 * haptic. The copy splits attached URLs from described-and-finding entries,
 * so an expert who only named a study isn't told they "added" a reference
 * that isn't visible yet. A no-op publish wrote nothing and says nothing.
 */
export function useProvidePublishedFeedback() {
  const toast = useToaster();

  const haptic = useHaptic();

  return useCallback(
    (result: PublishProvidedStatementReferencesResult) => {
      if (result.noop) {
        return;
      }

      haptic.success();

      toast.showSuccess(
        formatProvidePublishToast(
          result.appendedReferences.length,
          result.helpRequestedStatementIndices.length
        )
      );
    },
    [haptic, toast]
  );
}
